import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { BlueContainer, Button } from '@app/shared/ui/atoms/Common';
import {
  StatusButton,
  type StatusButtonVariant,
  ListItemRow,
} from '@app/shared/ui/atoms/Admin/Withdrawals';
import { formatBalance } from '@app/shared/utils/common';
import { Page } from '@app/routes';
import { PriceType } from '@app/shared/types/common';

interface ListItemProps {
  withdrawalId: number;
  telegramTag?: string | null;
  telegramId?: string | null;
  status: StatusButtonVariant;
  amount: string;
}

export function ListItem({ withdrawalId, telegramTag, telegramId, status, amount }: ListItemProps) {
  const { t } = useTranslation();

  return (
    <BlueContainer withShadow className="flex items-center gap-2" asChild>
      <li>
        <div className="flex flex-1 flex-col gap-1">
          <ListItemRow label="Telegram" value={<b>{telegramTag}</b>} />
          <ListItemRow label="Telegram ID" value={<b>{telegramId}</b>} />
          <ListItemRow
            label={t('admin_withdrawals.status')}
            value={<StatusButton variant={status} as="span" className="py-0.5" />}
          />
          <ListItemRow
            label={t('admin_withdrawals.amount')}
            value={<b>{formatBalance(PriceType.TON, amount)}</b>}
          />
        </div>

        <Button
          variant="secondary"
          size="sm"
          className="flex w-fit items-center justify-center px-2.5"
          asChild
        >
          <Link to={`${Page.ADMIN_WITHDRAWALS}/${withdrawalId}`}>
            {t('admin_withdrawals.start_checking')}
          </Link>
        </Button>
      </li>
    </BlueContainer>
  );
}
